/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import Canonical from '../../../../components/common/layout/Canonical'
import CorporateHeader from '../../../../components/common/layout/CorporateHeader';
import AboutProject from '../../../../components/corporate/corporate/home/AboutProject';
import Banner from '../../../../components/corporate/corporate/home/Banner';
import JobOpening from '../../../../components/corporate/corporate/home/JobOpening';
import Properties from '../../../../components/corporate/corporate/home/Properties';
import QuickLinks from '../../../../components/corporate/corporate/home/QuickLinks';
import RecentUpdates from '../../../../components/corporate/corporate/home/RecentUpdates';
import SocialMedia from '../../../../components/corporate/corporate/home/SocialMedia';
import { useSitemap } from '../../../../shared/hooks/use-sitemap';
import useAxios from '../../../../shared/hooks/use-axios';
import { useSelector } from 'react-redux';
import { url } from '../../../../shared/utils/url';
import Error from '../../../../components/common/form/Error';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const Home = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<any>(null);
    const [isError, setIsError] = useState<boolean>(false);
    useSitemap();

    const getHomePageData = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.corporate_homepage}`);

            if (res && res.status === 200) {
                setData(res?.data)
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            setData(null)
            console.error("error while fetching corporate home page data", error);
        }
    }

    useEffect(() => {
        !!lang && getHomePageData();
    }, [lang])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.corporate_home.title")}</title>
                <meta name="description" content={t("seo_friendly.corporate_home.desc")} />
                <meta name="keywords" content={t("seo_friendly.corporate_home.keywords")} />
            </Helmet>

            <div className="dark:bg-bgDarkDull bg-white w-full h-full">
                <div className={`w-full ${!isError ? "h-[425px] mdm:h-[510px] lg:h-full 1.5xl:h-[841px]" : "h-auto"} relative`}>
                    {!isError && <Banner data={data} />}

                    {/* header */}
                    <div className="absolute top-0 left-0 right-0 flex items-start w-full z-[2]">
                        <CorporateHeader bg={!isError} />
                    </div>
                </div>
            </div>

            {!isError ? <div id="home" className="dark:bg-bgDarkDull bg-white">
                <RecentUpdates data={data} />
                <AboutProject data={data} />
                <JobOpening />
                <Properties />
                <SocialMedia />
                <QuickLinks data={data} />
            </div> :
                <div className='h-[620px] xlx:h-[750px] flex items-center justify-center'>
                    <Error />
                </div>
            }
        </>
    );
};

export default Home;